(function (window) {
    let mainController = {};
    mainController.init = function () { };
    mainController.showModal = function (modal) {
        debugger;
        modal.show();
        modal.addClass('in');
    };
    mainController.hideModal = function (modal) {
        modal.hide();
        modal.removeClass('in');

        $(document).trigger('hideModal', modal.attr('id'));
    };
    mainController.validateEmail = function (email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());

        // var re = /^[a-zA-Z0-9.!#$%&‚Äô*+/=?^_{|}~-]+@[a-zA-Z0-9-]+(?:.[a-zA-Z0-9-]+)*$/;
        // return re.test(email);
    };
    mainController.validateUrl = function (str) {
        var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|'+ // domain name
            '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
            '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
            '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
        return pattern.test(str);
    };
    mainController.linkHeaderStatus = function (link) {
        return $.ajax({
            url: API.URL.LINK_CHECK,
            type: 'GET',
            async: false,
            data: { link: link },
            success: function(data) {
                if(data.status) {
                    return data.status;
                }

                return 200;
            },
            error: function (jqXhr, textStatus, errorMessage) {
                console.log(errorMessage);
            }
        });
    };
    mainController.setCookie = function (name, value, days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    };
    mainController.getCookie = function (name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    };

    window.mainController = mainController;
})(window);

(function () {
    $('#cookiesModal').fadeIn();
    $("body").on('click', '#closeBtnCookiesBanner', function (e) {
        $('#cookiesModal').fadeOut();
        document.cookie = "confirmUsing=1; max-age=" + 31536000 + "; path=/";
    });
})();

/** вызов попапа регистрации по get-параметру */
(function () {
    var openGet = "openregpopup";
    var search = window.location.search;

    if (search && search.indexOf(openGet) !== -1) {
        $('#sclModal').modal('show');
    }
})();
